module.exports = __webpack_public_path__ + "static/media/trckr_demo.40377174.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/trckr_demo.png
// module id = 98
// module chunks = 0